import React from 'react';
import voca from 'voca';
import parse from 'html-react-parser';
import TooltipInfo from '../../common/docs/TooltipInfo';

export const CollectionCard = ({
  imageUrl,
  title,
  description,
  backgroundColor,
  value,
  handleSetState,
  selected,
}) => {
  return (
    <div
      className={`card card--user-profile ml-4 card--collection-source ${
        selected ? 'card--collection-source-active' : ''
      }`}
      onClick={() => handleSetState(value)}
    >
      {/* <div className={`card--user-profile__cover ${backgroundColor}`}> </div> */}
      <div className={`card--user-profile__cover`}> </div>
      <div className="card-body">
        <figure className="avatar avatar--online">
          <div className="avatar__thumbnail">
            <img src={imageUrl} alt={title} className="avatar__image" />
          </div>
          <figcaption className="avatar__meta">
            <h5 className="avatar__title js-user-name" title={title}>
              {voca.truncate(title, 20)}{' '}
              <TooltipInfo
                title={`Click on a card to ${description}`}
                headerText={title}
                showHeader={true}
                showArrow={true}
                append={false}
              />
            </h5>
            <div className="avatar__summery js-multiline-truncate" title={description}>
              {parse(voca.truncate(description, 110))}
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
  );
};
